import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const mlbomApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getModelCards: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/mlbom`,
                params: {
                    product_or_type: data.filter.product_or_type,
                    publisher: data.filter.publisher,
                    task: data.filter.task,
                    license_family: data.filter.license_family,
                    has_unknown_type: data.filter.hasUnknownType,
                    sort_by: convertSortToQueryString(data.sort),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getModelCardComponents: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/mlbom/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
        getModelCardsTasks: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/mlbom/tasks`,
            }),
        }),
        getModelPublishers: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/mlbom/publishers`,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetModelCardsQuery, useGetModelCardComponentsQuery, useLazyGetModelPublishersQuery, useLazyGetModelCardsTasksQuery, } = mlbomApi;
//# sourceMappingURL=mlbom.api.js.map